<template>
    <v-card elevation="5">
        <v-card-title style="font-weight: 700; color: #004d40; background-color: #eee;">
            <slot name="cardTitle"></slot>
        </v-card-title>
        <v-card-subtitle style="color: #000; background-color: #eee;">
            <slot name="cardSubtitle"></slot>
        </v-card-subtitle>
        <v-card-text style="margin-bottom: 20px;">
            <slot name="cardText"></slot>
        </v-card-text>
    </v-card>
</template>

<script>
export default {}
</script>
